import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Content, Form, FormSubmit, TextInputControl } from '@/core/components';

import { UserSelectControl } from '../Nomen/User/UserSelectControl';
import { LaboratorySchema } from './model/LaboratorySchema';

interface LaboratoryFormProps extends FormSubmit<LaboratorySchema> {
  title: string;
}

export function LaboratoryForm(props: LaboratoryFormProps) {
  const { title, schema, defaultValues, values, isSubmitting, onCancel, onSubmit } = props;
  const { t } = useTranslation();
  const form = useForm<LaboratorySchema>({
    defaultValues,
    values,
    resolver: zodResolver(schema),
  });

  return (
    <FormProvider {...form}>
      <Form
        title={title}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <Stack>
          <Content type="full">
            <TextInputControl<LaboratorySchema>
              name="name"
              label={t('laboratories.form.fields.name')}
              isSubmitting={isSubmitting}
            />
            <TextInputControl<LaboratorySchema>
              name="description"
              label={t('laboratories.form.fields.description')}
              isSubmitting={isSubmitting}
            />
            <UserSelectControl<LaboratorySchema>
              name="labChief"
              label={t('laboratories.form.fields.labChief')}
              isSubmitting={isSubmitting}
              withAsterisk
            />
            <TextInputControl<LaboratorySchema>
              name="websiteLink"
              label={t('laboratories.form.fields.websiteLink')}
              isSubmitting={isSubmitting}
            />
            <TextInputControl<LaboratorySchema>
              name="domain"
              label={t('laboratories.form.fields.domain')}
              isSubmitting={isSubmitting}
            />
            <TextInputControl<LaboratorySchema>
              name="researchTeam"
              label={t('laboratories.form.fields.researchTeam')}
              isSubmitting={isSubmitting}
            />
          </Content>
        </Stack>
      </Form>
    </FormProvider>
  );
}
